import { render, staticRenderFns } from "./TituloTopoDaPagina.vue?vue&type=template&id=17fb8fcf&scoped=true"
import script from "./TituloTopoDaPagina.vue?vue&type=script&lang=js"
export * from "./TituloTopoDaPagina.vue?vue&type=script&lang=js"
import style0 from "./TituloTopoDaPagina.vue?vue&type=style&index=0&id=17fb8fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fb8fcf",
  null
  
)

export default component.exports